"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteUpdatedData = void 0;
var runtypes_1 = require("runtypes");
var runtypeImplementing_1 = require("../../../util/runtypeImplementing");
var UUID_1 = require("../../../util/UUID");
var Data_1 = require("./Data");
exports.SiteUpdatedData = (0, runtypeImplementing_1.runtypeImplementing)(Data_1.Data)((0, runtypes_1.Record)({
    type: (0, runtypes_1.Literal)("siteUpdated"),
    site: UUID_1.UUID,
    // Numeric timestamp as string.
    updatedAt: runtypes_1.String,
}));
//# sourceMappingURL=SiteUpdatedData.js.map